exports = module.exports = require("../../../../../../usr/lib/app/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "b-button[data-v-12f3c710]{cursor:pointer}", ""]);
